import { useEffect } from 'react';
import { useReferralCode } from '@package/smart-wallet/hooks';

/**
 * Global component to capture referral code from URL
 * Should be mounted at the top level of the app to ensure
 * code is captured before any navigation/redirects
 */
export const ReferralCodeCapture = () => {
  const { captureReferralCode } = useReferralCode();

  useEffect(() => {
    // Capture immediately on mount
    console.log('[ReferralCodeCapture] Component mounted, capturing code...');
    captureReferralCode();
  }, [captureReferralCode]);

  // This component doesn't render anything
  return null;
};
